import type { SessionResponse } from "@/types/session";

import { api, unwrap } from "./axiosConfig";

const BASE = "/api/v1/me/sessions";

export const sessionService = {
  async list(): Promise<SessionResponse[]> {
    return unwrap(api.get(BASE));
  },

  async revoke(sessionId: number): Promise<void> {
    await api.delete(`${BASE}/${sessionId}`);
  },

  async revokeOthers(): Promise<number> {
    const data = await unwrap<{ revoked_count: number }>(api.post(`${BASE}/revoke-others`));
    return data.revoked_count;
  },
};
